import { CustomerActionSummaryDto, ServiceProfile } from '@ampsec/platform-client';

export const COLUMN_STATE_STORAGE_KEYS = {
  server: 'engagementActionsGridColumnState',
} as const;

export const CUSTOM_ACTION_MENU_OPTIONS = [
  { id: 'delete', value: 'DELETE', label: 'Delete' },
  { id: 'execution', value: 'EXECUTION', label: 'Action execution history' },
] as const;

export type CustomActionMenuValue = (typeof CUSTOM_ACTION_MENU_OPTIONS)[number]['value'];

export interface AgGridEngagementActionsProps {
  serviceProfiles: ServiceProfile[];
  refreshToken: boolean;
  onEdit: (row: CustomerActionSummaryDto) => void;
  onDelete: (row: CustomerActionSummaryDto) => void;
  onExecution: (row: CustomerActionSummaryDto) => void;
  onViewFailedRuns: (row: CustomerActionSummaryDto) => void;
  tableBodyHeight?: string;
}

export const DEFAULT_COLUMN_STATE = [
  { colId: 'displayValue', width: null, hide: false, pinned: null, sort: null, flex: 1 },
  { colId: 'serviceKey', width: null, hide: false, pinned: null, sort: null, flex: 1 },
  { colId: 'triggered', width: null, hide: false, pinned: null, sort: null, flex: 0.75 },
  { colId: 'failedAttempts', width: null, hide: false, pinned: null, sort: null, flex: 0.75 },
  { colId: 'actions', width: null, hide: false, pinned: null, sort: null, flex: 0.35 },
];
